import { RouteComponentProps } from 'react-router-dom'
import { Review, Track, TrackLanguage, TrackGenre } from '../../Types'

export enum Tabs {
  all = 'all',
  added = 'added',
  reviewed = 'reviewed',
  missed = 'missed',
}

export enum CampaignStatus {
  pending_approval = 'pending_approval',
  approved = 'approved',
  scheduled = 'scheduled',
  running = 'running',
  ended = 'ended',
  payment_pending = 'payment_pending',
}

export enum ReviewStatus {
  reserved = 'reserved',
  awaiting_review = 'awaiting_review',
  reviewed = 'reviewed',
  missed = 'missed',
  canceled = 'canceled',
  skipped = 'skipped',
  replaced = 'replaced',
  unknown = '',
}

export interface CampaignTrack
  extends Omit<Track, 'TrackGenres' | 'TrackLanguages'> {
  spotify_popularity: number
  spotify_popularity_result: number
  artist_spotify_id: string
  TrackGenres: Array<TrackGenre>
  TrackLanguages: Array<TrackLanguage>
  Artist: {
    user_id: number
    User: {
      first_name: string
      id: number
      last_name: string
      user_photo_url: string
    }
  }
}

export interface CampaignDetailsData {
  Reviews: Array<Review>
  Track: CampaignTrack
  budget: number
  curators_count: number
  curators_count_max?: number
  listeners_count: number
  streams_count: number
  end_date: Date
  id: number
  playlists_adds: number
  playlists_count: number
  playlists_count_max?: number
  playlists_followers_result: number
  start_date: Date
  status: CampaignStatus
  refund: number
  is_sfa_connected: boolean
  reviewed_count: number
  reviews_count: number
  missed_cound: number
  artist_spotify_id: string
  is_feed?: boolean
  type?: string
}

export type CampaignResultsProps = RouteComponentProps<{
  campaignID: string
}>
